import {
  WHATSAPP_OTP_REQUIRED,
  WHATSAPP_OTP_SENT,
  WHATSAPP_OTP_VERIFIED,
  WHATSAPP_OTP_ERROR,
  SHOW_WHATSAPP_OTP_DIALOG,
  HIDE_WHATSAPP_OTP_DIALOG
} from '../actions/types';

const initialState = {
  otpRequired: false,
  showOTPDialog: false,
  userID: null,
  userobj: null,
  loading: false,
  error: null
};

const whatsappOTPReducer = (state = initialState, action) => {
  switch (action.type) {
    case WHATSAPP_OTP_REQUIRED:
      return {
        ...state,
        otpRequired: true,
        showOTPDialog: true,
        userID: action.userID,
        userobj: action.userobj,
        loading: false,
        error: null
      };

    case WHATSAPP_OTP_SENT:
      return {
        ...state,
        loading: false,
        error: null
      };

    case WHATSAPP_OTP_VERIFIED:
      return {
        ...state,
        otpRequired: false,
        showOTPDialog: false,
        userID: null,
        userobj: null,
        loading: false,
        error: null
      };

    case WHATSAPP_OTP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case SHOW_WHATSAPP_OTP_DIALOG:
      return {
        ...state,
        showOTPDialog: true
      };

    case HIDE_WHATSAPP_OTP_DIALOG:
      return {
        ...state,
        showOTPDialog: false,
        otpRequired: false,
        userID: null,
        userobj: null,
        error: null
      };

    default:
      return state;
  }
};

export default whatsappOTPReducer; 